import { buildApiUrl } from '../config';
import useAPI from '../../hooks/useAPI';
import { useState } from 'react';
import { z } from 'zod';

// Import existing types to use in function signatures
import { Contact } from '../../types/backendResponses/Contact';
import { ContactResponseSchema } from '../schemas/contactSchemas';

/**
 * Hook for getting contacts by customer ID with built-in state management
 * Includes Zod validation for type safety
 */
export const useGetContactsByCustomerId = () => {
  const { callAPI } = useAPI(); // GET

  const [data, setData] = useState<Contact[] | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  /**
   * Get contacts by customer ID
   * @param customerId - The customer ID
   * @returns Promise with boolean indicating success
   */
  const action = async (customerId: string): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await callAPI(buildApiUrl(`contact/${customerId}`));

      // Validate the response data
      const validatedData =
        /*  z.array(ContactResponseSchema).parse( */ response /* ) */ as Contact[];

      setData(validatedData);
      return true;
    } catch (error) {
      console.error('Error in useGetContactsByCustomerId:', error);
      setError(error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    action,
  };
};
